export default "__VITE_ASSET__DXVYLDz8__"